import { Box, Flex, Icon, Text, VStack } from '@chakra-ui/react';
import {
  NotificationTemplateListItemFragment,
  TransactionStageType,
} from '@client/graphql/__generated__/types';
import { LucideIcon } from 'lucide-react';
import { AddNotificationButton } from './AddNotificationButton';
import { NotificationTemplateCard } from './NotificationTemplateCard';

interface PipelineColumnProps {
  label: string;
  icon: LucideIcon;
  eventType: TransactionStageType;
  templates: NotificationTemplateListItemFragment[];
  showPartner?: boolean;
  showAddButton?: boolean;
}

export const PipelineColumn = ({
  label,
  icon,
  eventType,
  templates,
  showPartner = false,
  showAddButton = false,
}: PipelineColumnProps) => {
  return (
    <Flex
      bg="whiteAlpha.50"
      border="1px solid"
      borderColor="whiteAlpha.50"
      borderRadius="2xl"
      direction="column"
      flexShrink={0}
      height="100%"
      overflow="hidden"
      width="345px"
    >
      {/* Column Header */}
      <Flex
        alignItems="center"
        bg="whiteAlpha.50"
        borderBottom="1px solid"
        borderColor="whiteAlpha.100"
        gap={3}
        p={4}
      >
        <Flex
          alignItems="center"
          bg="purpleGradientReverse"
          borderRadius="sm"
          justifyContent="center"
          minHeight="40px"
          minWidth="40px"
        >
          <Icon as={icon} boxSize={5} color="black" />
        </Flex>
        <Box>
          <Text
            color="whiteAlpha.600"
            fontSize="xs"
            letterSpacing="wider"
            textTransform="uppercase"
          >
            Event
          </Text>
          <Text color="white" fontSize="md">
            {label}
          </Text>
        </Box>
      </Flex>

      {/* Column Content */}
      <VStack
        alignItems="stretch"
        css={{
          '&::-webkit-scrollbar': {
            width: '6px',
          },
          '&::-webkit-scrollbar-track': {
            background: 'transparent',
          },
          '&::-webkit-scrollbar-thumb': {
            background: 'rgba(255, 255, 255, 0.2)',
            borderRadius: '3px',
          },
        }}
        flex={1}
        overflowY="auto"
        p={4}
        spacing={4}
      >
        {templates.map((template) => (
          <NotificationTemplateCard
            key={template.id}
            showPartner={showPartner}
            template={template}
          />
        ))}
        {showAddButton && <AddNotificationButton eventType={eventType} />}
        {templates.length === 0 && !showAddButton && (
          <Flex
            alignItems="center"
            border="1px dashed"
            borderColor="whiteAlpha.200"
            borderRadius="lg"
            height="100px"
            justifyContent="center"
          >
            <Text color="whiteAlpha.400" fontSize="sm">
              No notifications
            </Text>
          </Flex>
        )}
      </VStack>
    </Flex>
  );
};
